import { render, staticRenderFns } from "./CardAtualizacoesCliente.vue?vue&type=template&id=80e871a6&scoped=true&"
import script from "./CardAtualizacoesCliente.vue?vue&type=script&lang=js&"
export * from "./CardAtualizacoesCliente.vue?vue&type=script&lang=js&"
import style0 from "./CardAtualizacoesCliente.vue?vue&type=style&index=0&id=80e871a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e871a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
